import { Button } from "@mui/material"

export const HiddenButton = (props: { onClick: () => void; label: string }) => {
  return (
    <Button
      onClick={props.onClick}
      sx={{
        "&.MuiButton-root": {
          border: "1px solid #e0ddf2",
          borderRadius: "15px",
          width: "212px",
          height: "33px",
          background: "white",
          color: "#1a0549",
          padding: "0",

          "&:hover": {
            cursor: "pointer",
            background: " #1a0549",
            borderColor: " #1a0549",
            color: "white",
          },
        },
      }}
    >
      {props.label}
    </Button>
  )
}
